import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";
import "./AdminShiftBulkImport.css";

const TEMPLATE_CSV = `memberId,date,shift_code
E00001,2026-04-01,A
E00001,2026-04-02,A
`;

/* ヘッダーなしでも可（1列目:社員コード / 2列目:日付 / 3列目:シフト） */

/**
 * 全員分シフト一括取込（POST /api/shifts/bulk-import/）
 * 列: memberId, date (YYYY-MM-DD), shift_code または shift_preset_id
 */
const AdminShiftBulkImport = () => {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError("ファイルを選択してください。");
      return;
    }
    setLoading(true);
    setError("");
    setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("year", String(year));
      fd.append("month", String(month));
      const res = await api.post("/api/shifts/bulk-import/", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(res.data);
    } catch (err) {
      const data = err.response?.data;
      const base = data?.message || err.message || "取込に失敗しました。";
      const rowErrs = Array.isArray(data?.errors) ? data.errors : [];
      const detail =
        rowErrs.length > 0
          ? `\n${rowErrs
              .slice(0, 30)
              .map((e) => (e.row != null ? `行${e.row}: ${e.message}` : e.message))
              .join("\n")}${rowErrs.length > 30 ? `\n…他 ${rowErrs.length - 30} 件` : ""}`
          : "";
      setError(base + detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shift-import-page">
      <Link to="/admin/workstime/schedule" className="shift-import-back">← スケージュールに戻る</Link>

      <header className="shift-import-header">
        <h2 className="shift-import-title">全員スケジュール一括取込</h2>
        <p className="shift-import-subtitle">
           CSV。1行目はヘッダー。<strong>1行目にヘッダーがなくても取り込めます</strong>（その場合は列順が{" "}
          <code>社員コード, 日付(YYYY-MM-DD), シフト</code> である必要があります）。ヘッダーありの場合は{" "}
          <code>memberId</code> / <code>date</code> / <code>shift_code</code>（またはシフト名）を推奨。シフトは{" "}
          管理画面のシフトコード（例: A）または「休」「有給」などシフト名でも可。<strong>対象年・月は CSV の日付の月と一致</strong>
          させてください。その月分はファイルで置き換えます。
        </p>
      </header>

      <div className="shift-import-panel">
        <h3 className="shift-import-panel-title">テンプレート（記入例）</h3>
        <pre className="shift-import-template">{TEMPLATE_CSV}</pre>
      </div>

      <div className="shift-import-panel">
        <h3 className="shift-import-panel-title">ファイルを取り込む</h3>
        <form onSubmit={handleSubmit}>
          <div className="shift-import-fields">
            <label className="shift-import-field">
              対象年
              <input
                type="number"
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
                min={2020}
                max={2100}
              />
            </label>
            <label className="shift-import-field">
              対象月
              <input
                type="number"
                value={month}
                onChange={(e) => setMonth(Number(e.target.value))}
                min={1}
                max={12}
              />
            </label>
            <label className="shift-import-field">
              ファイル
              <input type="file" accept=".csv,.xlsx,.xls" onChange={(e) => setFile(e.target.files?.[0] || null)} />
            </label>
          </div>
          <button type="submit" className="shift-import-submit" disabled={loading}>
            {loading ? "取込中…" : "アップロードして取込"}
          </button>
        </form>

        {error && (
          <div className="shift-import-alert is-error" role="alert">
            {error}
          </div>
        )}

        {result && (
          <div style={{ marginTop: 16 }}>
            <p className="shift-import-result-message">{result.message}</p>
            {(() => {
              const skipped = Array.isArray(result.skipped_rows)
                ? result.skipped_rows
                : Array.isArray(result.errors)
                  ? result.errors
                  : [];
              if (skipped.length === 0) return null;
              return (
                <div className="shift-import-skipped">
                  <strong>取り込めなかった行（該当日のシフトは未登録です。その他の行は反映済み）</strong>
                  <ul>
                    {skipped.slice(0, 50).map((er, i) => (
                      <li key={i}>
                        {er.row != null ? `行 ${er.row}: ` : ""}
                        {er.message}
                      </li>
                    ))}
                  </ul>
                  {skipped.length > 50 && <p>…他 {skipped.length - 50} 件</p>}
                </div>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminShiftBulkImport;
